import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { Table } from "../../../../../components/table/Table";
import {
  RoamingRowSubComponent,
  RoamingRowSubComponentMobile,
} from "../../../../spson/roamingTables/RoamingRowSubComponent";
import { useProfileRoamingDevices } from "../useProfileRoamingDevices";
import { Mobile, NotMobile } from "../../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../../hooks";
import {
  COLUMNS,
  COLUMNS_MOBILE,
  SEARCH_KEYS,
  INITIAL_SORT,
} from "./ProfileRoamingDevicesTable.consts";
import { ProfileRoamingDevicesTableHeader } from "./components";

export const ProfileRoamingDevicesTable = ({ profileName }) => {
  const roamingDevices = useProfileRoamingDevices(profileName);
  const translate = useIntlTranslate();
  const caption = translate(
    `${
      _.isEmpty(roamingDevices)
        ? "roaming_devices_table_description"
        : "roaming"
    }`
  );

  const subHeader = _.isEmpty(roamingDevices) && (
    <FormattedMessage id="roaming_devices_table_description" />
  );

  return (
    <Fragment>
      <Mobile>
        <Table
          header={<ProfileRoamingDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          data={roamingDevices}
          hiddenColumns={["protectionStatus", "lastSeen"]}
          columns={COLUMNS_MOBILE}
          renderRowSubComponent={RoamingRowSubComponentMobile}
          defaultSorted={INITIAL_SORT}
          noDataMessageID={"no_devices_found"}
          subHeader={subHeader}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <NotMobile>
        <Table
          header={<ProfileRoamingDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          data={roamingDevices}
          columns={COLUMNS}
          renderRowSubComponent={RoamingRowSubComponent}
          defaultSorted={INITIAL_SORT}
          noDataMessageID={"no_devices_found"}
          subHeader={subHeader}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </NotMobile>
    </Fragment>
  );
};
